// src/components/table/columnsConfig.js
import React from "react";

import SVG from "../../svg/Svg.tsx";
import { getStationDisplayProps } from "../../../utils/getStationState.ts";
import { formatApiKeyLastUsedAt } from "../../../utils/orgApiKeyLastUsedAt.ts";

// Единый конфиг для всех типов таблиц
const createColumns = (actions) => {
  const { Edit, setOrg, goto } = actions;

  return {
    organizations: [
      {
        key: "name",
        title: "ОРГАНИЗАЦИЯ",
        width: "200px",
        render: (item) => (
          <div
            onClick={() => {
              goto(item);
            }}
            style={{ cursor: "pointer" }}
          >
            {item.name}
          </div>
        ),
      },
      { key: "location", title: "ГОРОД", width: "150px" },
      { key: "adress", title: "АДРЕС", width: "300px" },
      { key: "description", title: "ОПИСАНИЕ", width: "340px" },
      {
        // `п. 18`: в карточке видно, пользуются ли ключом. Сам ключ и его хэш
        // сервер не отдаёт — только отметку времени.
        key: "apiKeyLastUsedAt",
        title: "ПОСЛЕДНЕЕ ОБРАЩЕНИЕ ПО КЛЮЧУ",
        width: "220px",
        render: (item) => formatApiKeyLastUsedAt(item.apiKeyLastUsedAt),
      },
      {
        key: "actions",
        title: "",
        width: "10px",
        render: (item) => (
          <div className="table_action">
            <div
              onClick={() => {
                Edit(item);
                setOrg(item);
              }}
            >
              {SVG["pen_green"]}
            </div>
          </div>
        ),
      },
    ],

    modules: [
      {
        key: "charge_id",
        title: "ИДЕНТИФИКАТОР",
        width: "100px",
        render: (item) => (
          <div
            onClick={() => Edit(item["Plant.id"], item.id)}
            style={{ cursor: "pointer" }}
          >
            {item.charge_id}
          </div>
        ),
      },
      {
        key: "status",
        title: "СТАТУС",
        width: "100px",
        render: (module) => (
          <div
            style={{
              color: module.status === "online" ? "#48ba67" : "#ff5454",
            }}
          >
            {module.status === "online" ? "на связи" : "нет связи"}
          </div>
        ),
      },
      { key: "serial", title: "СЕРИЙНЫЙ НОМЕР", width: "100px" },
      { key: "Line.name", title: "ЛИНИЯ", width: "100px" },
      {
        key: "Plant.name",
        title: "ОБЪЕКТ",
        width: "400px",
        render: (item) => (
          <div
            onClick={() => setOrg(item["Plant.id"], item.id)}
            style={{ cursor: "pointer", color: "var(--logo)" }}
          >
            {item["Plant.name"]}
          </div>
        ),
      },
    ],

    stations: [
      {
        key: "serial",
        title: "СЕРИЙНЫЙ НОМЕР",
        width: "120px",
        render: (item) => (
          <div
            onClick={() => Edit(item["Plant.id"], item.id)}
            style={{ cursor: "pointer" }}
          >
            {item.serial ?? "—"}
          </div>
        ),
      },
      { key: "place", title: "МЕСТО УСТАНОВКИ", width: "120px" },
      {
        key: "Module.charge_id",
        title: "ИДЕНТИФИКАТОР МОДУЛЯ",
        width: "150px",
      },
      { key: "Module.Line.name", title: "ЛИНИЯ", width: "120px" },
      {
        key: "Plant.name",
        title: "ОБЪЕКТ",
        width: "120px",
        render: (item) => (
          <div
            onClick={() => setOrg(item["Plant.id"], item.id)}
            style={{ cursor: "pointer", color: "var(--logo)" }}
          >
            {item["Plant.name"]}
          </div>
        ),
      },
      {
        key: "state_id",
        title: "СОСТОЯНИЕ",
        width: "120px",
        render: (item) => {
          const { state, color, icon } = getStationDisplayProps(item);
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "10px",
                color,
                paddingRight: "8px",
              }}
            >
              <span>{state}</span>
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {React.cloneElement(icon, {
                  fill: color,
                  width: 18,
                  height: 18,
                })}
              </div>
            </div>
          );
        },
      },
    ],

    users: [
      { key: "email", title: "e-mail", width: "250px" },
      { key: "role", title: "РОЛЬ", width: "100px" },
      { key: "company", title: "ОРГАНИЗАЦИЯ", width: "250px" },
      { key: "tel", title: "ТЕЛЕФОН", width: "100px" },
      {
        key: "actions",
        title: "",
        width: "10px",
        render: (item) => (
          <div onClick={() => actions.Edit(item)}>{SVG["pen_green"]}</div>
        ),
      },
    ],
    stationsInModule: [
      {
        key: "controller_address",
        title: "Адрес контроллера",
        width: "40px",
        render: (item) => {
          const { onCellChange } = actions; // ← получаем из замыкания
          return (
            <input
              type="text"
              name="controller_address"
              value={item.controller_address || ""}
              onChange={(e) => onCellChange(e, item.id)}
              className={
                item.__modified?.includes("controller_address")
                  ? "field-changed"
                  : ""
              }
              maxLength={2}
              disabled={true}
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "Meters.meter_address",
        title: "Адрес счётчика",
        width: "100px",
        render: (item) => {
          const { onCellChange } = actions;
          const value = item["Meters.meter_address"];
          const displayValue = Number(value) === 0 ? "" : value;

          return (
            <input
              type="number"
              name="Meters.meter_address"
              value={displayValue}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 5) {
                  onCellChange(e, item.id);
                }
              }}
              className={
                item.__modified?.includes("Meters.meter_address")
                  ? "field-changed"
                  : ""
              }
              min="0"
              max="99999"
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "Meters.meter_number",
        title: "Номер счётчика",
        width: "100px",
        render: (item) => {
          const { onCellChange } = actions;
          return (
            <input
              type="text"
              name="Meters.meter_number"
              value={
                (item["Meters.meter_number"] || "") === "0"
                  ? ""
                  : item["Meters.meter_number"] || ""
              }
              onChange={(e) => onCellChange(e, item.id)}
              className={
                item.__modified?.includes("Meters.meter_number")
                  ? "field-changed"
                  : ""
              }
              maxLength={20}
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "place",
        title: "Место установки",
        width: "100px",
        render: (item) => {
          const { onCellChange } = actions;
          return (
            <input
              type="text"
              name="place"
              value={item.place || ""}
              onChange={(e) => onCellChange(e, item.id)}
              className={
                item.__modified?.includes("place") ? "field-changed" : ""
              }
              maxLength={10}
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "serial",
        title: "Серийный номер",
        width: "100px",
        render: (item) => {
          const { onCellChange } = actions;
          return (
            <input
              type="text"
              name="serial"
              value={item.serial || ""}
              onChange={(e) => onCellChange(e, item.id)}
              className={
                item.__modified?.includes("serial") ? "field-changed" : ""
              }
              maxLength={20}
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      // DEV-56 (152-Q5 п. 1): колонка почты владельца убрана — сервер её больше
      // не отдаёт (GET /plantData/:id), а показывать ПДн третьих лиц в карточке
      // объекта нельзя. Занятость станции — has_owner, отдельной колонки нет.
      // Добавь другие поля, если нужно: id, module_id и т.д.
    ],

    childModules: [
      {
        key: "charge_id",
        title: "Идентификатор",
        width: "12%",
        render: (item, index) => {
          const { onCellChange } = actions;
          return (
            <input
              type="text"
              name="charge_id"
              value={item.charge_id || ""}
              onChange={(e) => onCellChange(e, item.id, index)}
              className={
                item.__modified?.includes("charge_id") ? "field-changed" : ""
              }
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "serial",
        title: "Серийный номер",
        width: "16%",
        render: (item, index) => {
          const { onCellChange } = actions;
          return (
            <input
              type="text"
              name="serial"
              value={item.serial || ""}
              onChange={(e) => onCellChange(e, item.id, index)}
              className={
                item.__modified?.includes("serial") ? "field-changed" : ""
              }
              maxLength={20}
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      {
        key: "primary_current",
        title: "Первичный ток ТТ",
        width: "12%",
        render: (item, index) => {
          const { onCellChange } = actions;
          return (
            <input
              type="number"
              name="primary_current"
              value={item.primary_current || ""}
              onChange={(e) => onCellChange(e, item.id, index)}
              className={
                item.__modified?.includes("primary_current") ? "field-changed" : ""
              }
              style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
            />
          );
        },
      },
      // временно коментируем поля о счетчиках
      // {
      //   key: "meter_address",
      //   title: "Адрес счётчика",
      //   width: "12%",
      //   render: (item, index) => {
      //     const { onCellChange } = actions;
      //     const value = item.meter_address;
      //     const displayValue = Number(value) === 0 ? "" : value;

      //     return (
      //       <input
      //         type="number"
      //         name="meter_address"
      //         value={displayValue}
      //         onChange={(e) => {
      //           const value = e.target.value;
      //           if (value.length <= 5) {
      //             onCellChange(e, item.id, index);
      //           }
      //         }}
      //         className={
      //           item.__modified?.includes("meter_address") ? "field-changed" : ""
      //         }
      //         min="0"
      //         max="99999"
      //         style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
      //       />
      //     );
      //   },
      // },
      // {
      //   key: "meter_number",
      //   title: "Номер счётчика",
      //   width: "16%",
      //   render: (item, index) => {
      //     const { onCellChange } = actions;
      //     return (
      //       <input
      //         type="text"
      //         name="meter_number"
      //         value={
      //           (item.meter_number || "") === "0" ? "" : item.meter_number || ""
      //         }
      //         onChange={(e) => onCellChange(e, item.id, index)}
      //         className={
      //           item.__modified?.includes("meter_number") ? "field-changed" : ""
      //         }
      //         maxLength={20}
      //         style={{ width: "100%", padding: "2px", boxSizing: "border-box" }}
      //       />
      //     );
      //   },
      // },
      // {
      //   key: "last_reading",
      //   title: "Показания счётчика",
      //   width: "18%",
      //   render: (item) => (
      //     <span>{item.last_reading || "—"}</span>
      //   ),
      // },
      {
        key: "Line.current_limit_line",
        title: "Лимит линии",
        width: "12%",
        render: (item) => (
          <span>{item["Line.current_limit_line"] ?? item["current_limit_line"] ?? "—"} A</span>
        ),
      },
      {
        key: "status",
        title: "Статус",
        width: "14%",
        render: (item) => (
          <span
            style={{
              color: item.status === 'online' ? "#28a745" : "#dc3545",
            }}
          >
            {item.status === 'online' ? "онлайн" : "офлайн"}
          </span>
        ),
      },
    ],
  };
};

export default createColumns;
